export const getRequiredChamberSlotsForTwoEndcaps = ( chamberEndcapLength, chamberLength ) => {
    /* NOTE:This is important logic to enable
        endcaps... In some cases, two endcaps don't fit
        in a single empty chamber space, meaning that
        one empty space in between chambers cannot
        fit two endcaps(from upper chamber and lower chamber),
        this is calculated by checking how many chamber slots
        are needed to allocate 2 endcaps */
    let requiredChamberSlotsforTwoEndcaps = Math.ceil(
        ( chamberEndcapLength * 2 ) / chamberLength,
    );
    return requiredChamberSlotsforTwoEndcaps;
};

export const calculatePolygonArea = ( points, signed ) => {
    const l = points.length, isSigned = signed || false;
    let det = 0;
    points = points.map(normalize);
    if (points[0] !== points[points.length - 1])
        points = points.concat(points[0]);

    for (let i = 0; i < l; i++)
        det += points[i].x * points[i + 1].y
            - points[i].y * points[i + 1].x;
    if (isSigned)
        return det / 2;
    else
        return det / 2;

    function normalize( point ) {
        if (Array.isArray(point))
            return {
                x: point[0],
                y: point[1],
            };
        else
            return point;
    }
};



// WEBPACK FOOTER //
// ./src/lib/chamberBed/utils.js